// sliceをimport
import { reducer as ClientIdReducer } from '../slice/ClientIdSlice';
import { reducer as ConditionsReducer } from '../slice/ConditionsSlice';
import { reducer as SearchWordReducer } from '../slice/SearchWordSlice';
import { reducer as SearchResultReducer } from '../slice/SearchResultSlice';
import { reducer as SearchResultOffsetReducer } from '../slice/SearchResultOffset';
import { reducer as ScreenTransitionReducer } from '../slice/ScreenTransitionSlice';
import { reducer as MasterPrefectureReducer } from '../slice/MasterPrefectureSlice';
import { reducer as MasterInquireReducer } from '../slice/MasterInquireSlice';
import { reducer as MasterSlaReducer } from '../slice/MasterSlaSlice';
import { reducer as ScreenHistoryReducer } from '../slice/ScreenHistorySlice';
import { reducer as EstimateInquiryReducer } from '../slice/EstimateInquirySlice';

export const reducers = {
    ClientId: ClientIdReducer,
    Conditions: ConditionsReducer,
    SearchWord: SearchWordReducer,
    SearchResult: SearchResultReducer,
    SearchResultOffset: SearchResultOffsetReducer,
    ScreenTransition: ScreenTransitionReducer,
    MasterPrefecture: MasterPrefectureReducer,
    MasterInquire: MasterInquireReducer,
    MasterSla: MasterSlaReducer,
    ScreenHistory: ScreenHistoryReducer,
    EstimateInquiry: EstimateInquiryReducer,
};
